<!-- Patient_CarePlan.vue -->
<template>
  <PatientCarePlanLegacy
    :patient-identifier="patientIdentifier"
    :entity-id="entityId"
    @show-message="(msg, type) => $emit('show-message', msg, type)"
  />
</template>

<script>
import PatientCarePlanLegacy from '@/components/Patient_Drawer/Tabs/Patient_CarePlanLegacy.vue';

export default {
  name: 'PatientCarePlan',
  components: { PatientCarePlanLegacy },

  props: {
    patientIdentifier: { type: String, required: true },
    entityId: { type: Number, required: true },
  },

  emits: ['show-message'],
};
</script>
